import { SelectiveExceptionHandler } from '../../helpers'

export class ErrorNode {
  public errorClass: { new(): Error }
  public handlers: SelectiveExceptionHandler[] = []
  public children: ErrorNode[] = []

  constructor(errorClass) {
    this.errorClass = errorClass
  }

  public orderChildren() {
    if (this.children.length === 0) {
      return
    }
    let childA
    let childB
    for (let i = 0; i < this.children.length; i++) {
      childA = this.children[i]
      for (let x = i + 1; x < this.children.length; x++) {
        childB = this.children[x]
        if (x === i) {
          continue
        }
        if (new childB.errorClass() instanceof childA.errorClass) {
          childA.children.push(childB)
          this.children.splice(x, 1)
          i--
          x--
        }
      }
    }

    this.children.forEach((child) => child.orderChildren())
  }

  public getLowestInstance(error): ErrorNode {
    if ( error instanceof this.errorClass
    && this.children.every((child) => ! (error instanceof child.errorClass)) ) {
      return this
    }
    let result
    this.children.some((child) => {
      result = child.getLowestInstance(error)
      return typeof result !== 'undefined'
    })
    return result
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/models/errors/error-node.ts